import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { fetchPolicyHolderInfo, loadingUser } from "../../action";
import "../../../src/styles/theme.scss";
import { useTranslation } from "react-i18next";
import { Button, Grid, Typography, Input } from "@mui/material";
import ContractTable from "../Contract/ContractDetailsTable";
import PaymentTable from "./PaymentTable";
import PayementForm from "./PaymentForm";

function PaymentTab() {
  const SignInSuccess = useSelector((state) => state);
  const token = localStorage.getItem("token");
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const [insureeCheck, setInsureeCheck] = useState(false);
  const [currentUser, setCurrentUSer] = useState();
  const [showDialog, setShowDialog] = useState(false);
  const [policyHolderId, setPolicyHolderId] = useState();
  const [insureeData, setInsureeData] = useState();

  useEffect(() => {
    dispatch(loadingUser(token));
  }, []);
  useEffect(() => {
    if (SignInSuccess?.profileReducer?.currentUserResponseData) {
      setCurrentUSer(SignInSuccess?.profileReducer?.currentUserResponseData);
    }
  }, [SignInSuccess]);
  useEffect(() => {
    if (currentUser?.id) {
      dispatch(fetchPolicyHolderInfo(currentUser?.id));
    }
  }, [currentUser]);
  useEffect(() => {
    if (SignInSuccess?.profileReducer?.policyholderUserResponseData) {
      setPolicyHolderId(
        SignInSuccess?.profileReducer?.policyholderUserResponseData?.[0]
          .policyHolder
      );
    }
  }, [policyHolderId, SignInSuccess]);
  return (
    <Grid container>
      <Grid container display="flex" justifyContent="space-between">
        <Typography
          style={{
            fontSize: "24px",
            fontWeight: "bold",
            color: "#000",
            marginLeft: "20px",
          }}
        >
          {t("Payments")}
        </Typography>
      </Grid>
      <PaymentTable policyHolderId={policyHolderId} />
    </Grid>
  );
}

export default PaymentTab;
